import type * as React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

// File-local mark size (top-nav brand lockup). The mark is the real BRAMBO
// logo image (CHR-01 / ADR-0035, Fix 4 web half) sized to the legacy 32px mark
// slot, with the "BRAMBO" wordmark beside it.
const MARK_SIZE = 32;

// BRAMBO brand lockup: logo image mark + "BRAMBO" wordmark. Rendered exactly
// ONCE, in the top app-bar (ADR-0035 — single sticky top-nav, no sidebar).
export const Brand = (): React.JSX.Element => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" spacing={1.25} alignItems="center" sx={{ userSelect: 'none' }}>
      <Box
        component="img"
        src="/brambo-logo.png"
        alt={t('app.title')}
        sx={{
          width: MARK_SIZE,
          height: MARK_SIZE,
          flexShrink: 0,
          objectFit: 'contain',
          display: 'block',
        }}
      />
      <Typography
        component="span"
        sx={{ fontWeight: 800, fontSize: 18, letterSpacing: '-0.01em', color: 'text.primary' }}
      >
        {t('app.title')}
      </Typography>
    </Stack>
  );
};
